import { render, staticRenderFns } from "./DeleteBannerModal.vue?vue&type=template&id=71421271&scoped=true"
import script from "./DeleteBannerModal.vue?vue&type=script&lang=js"
export * from "./DeleteBannerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71421271",
  null
  
)

export default component.exports